import PopoverContent from './PopoverContent'
import styled from 'styled-components'

export default styled(PopoverContent)``
